import React from 'react';
import { withStyles, Grid, Hidden } from '@material-ui/core';
import SolidBackdrop from '../misc/SolidBackdrop';
import HeadlineText from '../misc/HeadlineText';
import FeatureSnippet from '../misc/FeatureSnippet';
import { green } from '@material-ui/core/colors';
import PostIcon from '@material-ui/icons/CloudUploadRounded';
import PeopleIcon from '@material-ui/icons/PeopleRounded';
import CheckIcon from '@material-ui/icons/DoneOutlineRounded';
import theme from '../../theme';
import LazyLoader from '../misc/LazyLoader';

const styles = theme => ({
    section: {
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
		},
		[theme.breakpoints.up('md')]: {
            padding: `${theme.spacing(4) * 1.5}px 0`
        },
        marginTop: 0,
        marginBottom: 0,
        zIndex: 1
    },
    descriptionText: {
        [theme.breakpoints.down('sm')]: {
            padding: `0 ${theme.spacing(2)}px`
		},
    },
    socialImage: {
        [theme.breakpoints.up('md')]: {
            width: 366,
        },
        [theme.breakpoints.down('sm')]: {
            width: '75%',
		},
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    icon: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%)`,
    }
});

class IndexSuccessSection extends React.Component {
	render() {
		const { classes } = this.props;

		return (
            <Grid
                container
                alignItems='center'
                spacing={10}
                className={classes.section}
            >
                <SolidBackdrop
                    image='https://specterr.b-cdn.net/bg-wave1.svg'
                    color={theme.palette.background.darker2}
                    shadow
                />
                <Hidden mdUp>
                    <Grid 
                        item
                        xs={12}
                        md={4}
                    >
                        <Grid
                            container
                            alignItems='center'
                            justify='center'
                            direction='column'
                            spacing={6}
                        >
                            <Grid item>
                                <HeadlineText align='center'>
                                    Are you maximizing your listeners?
                                </HeadlineText>
                            </Grid>
                            <Grid item style={{width: '100%'}}>
                                <LazyLoader
                                    placeholder={<img
                                        src='https://specterr.b-cdn.net/small.jpg'
                                        className={classes.image}
                                        alt='Logos of various social media platforms'
                                    />}
                                    offset={500}
                                >
                                    <img 
                                        src='https://specterr.b-cdn.net/social-icons.png' 
                                        className={classes.socialImage}
                                        alt='Logos of various social media platforms.'
                                    />
                                </LazyLoader>
                            </Grid>
                        </Grid>
                    </Grid>
                </Hidden>
                <Grid 
                    item 
                    xs={12}
                    md={8}
                >
                    <Grid
                        container
                        alignItems='center'
                        justify='center'
                        direction='column'
                        spacing={6}
                    >
                        <Grid item>
                            <FeatureSnippet
                                headline='POST EVERYWHERE'
                                description="
                                    A lot of artists don't take full advantage of social media to promote their releases.
                                    Video platforms like YouTube and TikTok are the biggest neglected opportunities.
                                    YouTube is the 2nd largest social platform in the world with almost 2 billion monthly users, but many artists don't post on it because they don't have a video for their track.
                                    Posting a great video on these platforms opens up a whole new audience for your music.
                                    If you don't post you are missing out on new fans and listeners. 
                                "
                                color={green['A400']}
                                icon={<PostIcon className={classes.icon}/>}
                            />
                        </Grid>
                        <Grid item>
                            <FeatureSnippet
                                headline='BOOST ENGAGEMENT'
                                description='
                                    Research has demonstrated that video is the most engaging content on social media. 
                                    Users are more likely to stop scrolling and view a post when a video catches their eye.
                                    Additionally, videos are liked and shared more frequently than links or pictures.
                                    So stop posting SoundCloud links, and start posting videos so people can hear your music instantly.
                                '
                                color={green['A400']}
                                icon={<PeopleIcon className={classes.icon}/>}
                            />
                        </Grid>
                        <Grid item>
                            <FeatureSnippet
                                headline='LEGITIMIZE YOUR BRAND'
                                description="
                                    Nowadays it's standard for professional artists to release videos for their tracks. 
                                    Not only does it increase brand recognition, but it functions as a status symbol that separates pros from hobbyists.
                                    You can signal how serious your brand is by how you choose to promote your music.
                                    Listeners pick up on these signals and naturally gravitate toward the artists that seem more established.
                                    With Specterr you can customize videos to fit your brand and make it stand out.
                                "
                                color={green['A400']}
                                icon={<CheckIcon className={classes.icon}/>}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Hidden smDown>
                    <Grid 
                        item
                        xs={12}
                        md={4}
                    >
                        <Grid
                            container
                            alignItems='center'
                            justify='center'
                            direction='column'
                            spacing={10}
                        >
                            <Grid item>
                                <HeadlineText align='center'>
                                    Are you maximizing your listeners?
                                </HeadlineText>
                            </Grid>
                            <Grid item style={{width: '100%'}}>
                                <img 
                                    src='https://specterr.b-cdn.net/social-icons.png' 
                                    className={classes.socialImage}
                                    alt='Logos of various social media platforms.'
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Hidden>
            </Grid>
		);
	}
}

export default withStyles(styles)(IndexSuccessSection);